import { LicenseBasicMonthlySubscriptionSubFormWebComponent } from './component/LicenseBasicMonthlySubscriptionSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_BASIC_MONTHLY_SUBSCRIPTION_SUBFORM } from '../../webcomponents.constants';

export { LicenseBasicMonthlySubscriptionSubFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_BASIC_MONTHLY_SUBSCRIPTION_SUBFORM,
  LicenseBasicMonthlySubscriptionSubFormWebComponent
);
